import React from 'react';
import { t } from '../utils/i18n';

const CommonModal = ({
  isOpen,
  onClose,
  title,
  children,
  footerChildren,
  showPrintButton = false,
  onPrint,
  size = 'lg',
  zIndex = 1050
}) => {
  if (!isOpen) return null;

  return (
    <div className={`modal fade ${isOpen ? 'show' : ''}`} style={{ display: isOpen ? 'block' : 'none', backgroundColor: 'rgba(0,0,0,0.5)', zIndex }} tabIndex="-1" aria-labelledby="modalLabel" aria-hidden={!isOpen}>
      <div className={`modal-dialog modal-dialog-centered modal-${size}` }>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="modalLabel">{title}</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            {children}
          </div>
          <div className="modal-footer justify-content-between">
            {footerChildren || (
              <>
                <div>
                  {showPrintButton && (
                    <button type="button" className="btn btn-primary me-2" onClick={onPrint}>
                      {t('print')}
                    </button>
                  )}
                </div>
                <button type="button" className="btn btn-secondary" onClick={onClose}>
                  {t('close')}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonModal;
